import { render } from "./IntegrationsList.vue?vue&type=template&id=4735061a"
import script from "./IntegrationsList.vue?vue&type=script&lang=js"
export * from "./IntegrationsList.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__